import $ from 'jquery'
import { castToFloatLocalized } from '@app/utils/string-helpers'

const TAB = 9
const ENTER = 13
const NUMERIC_INPUTS = [
  'integer',
  'currency',
  'currency_dc',
  'n_currency',
  'percentage',
]

export default class LiveInputsTextInput {
  constructor(liveInputs) {
    this.liveInputs = liveInputs
    this.inputUpdated = false
    this.handleInputFocus = this.handleInputFocus.bind(this)
    this.handleKeydownEvent = this.handleKeydownEvent.bind(this)
    this.tabDirection = 0
    this.initializeListeners()
  }

  inputFilter() {
    return "[data-behaviour~='live-inputs-text-input']"
  }

  initializeListeners() {
    this.liveInputs.on('keydown', this.inputFilter(), this.handleKeydownEvent)
    this.liveInputs.on('paste', this.inputFilter(), this.handleKeydownEvent)
    this.liveInputs.on('focus', this.inputFilter(), this.handleInputFocus)
    this.liveInputs.on('blur', this.inputFilter(), (event) => {
      this.update($(event.target))
      return this.liveInputs.removeNamespaceSelectedClass()
    })
  }

  handleInputFocus(event) {
    return this.liveInputs.focus($(event.target))
  }

  handleKeydownEvent(event) {
    const $input = $(event.target)
    this.initializeOriginalValue($input)

    if (
      $input.val() !== $input.data('originalValue') &&
      (event.which === TAB || event.which === ENTER)
    ) {
      const doneEditing = $input.is('textarea')
        ? event.which === TAB || (event.which === ENTER && event.metaKey)
        : true

      if (doneEditing) {
        this.updateTabDirection(event)

        this.update($input)
      }
    }

    return this.liveInputs.resizeInput($input, true)
  }

  teardown() {
    this.liveInputs.off('keydown', this.inputFilter(), this.handleKeydownEvent)
    this.liveInputs.off('focus', this.inputFilter(), this.handleInputFocus)
  }

  update($input) {
    this.initializeOriginalValue($input)
    if ($input.val() !== $input.data('originalValue')) {
      if (this.inputUpdated || !this.valueRemainsDefault($input)) {
        $input.data('originalValue', $input.val())
        this.inputUpdated = true
        return this.liveInputs.update($input)
      }
    }
  }

  valueRemainsDefault($input) {
    const defaultValueStr = $input.data('defaultValue')
    if (defaultValueStr === undefined) {
      return false
    }

    const currentValueStr = $input.val()
    const originalValueStr = $input.data('originalValue')

    if (NUMERIC_INPUTS.includes($input.data('valueType'))) {
      const precision = $input.data('precision') || 2
      const currentValue =
        castToFloatLocalized(currentValueStr).toFixed(precision)
      const defaultValue =
        castToFloatLocalized(defaultValueStr).toFixed(precision)

      if (originalValueStr) {
        const originalValue =
          castToFloatLocalized(originalValueStr).toFixed(precision)
        if (originalValue !== defaultValue) return false // Value was not default so changing to default is allowed
      }

      return currentValue === defaultValue
    } else {
      if (originalValueStr) {
        if (originalValueStr !== defaultValueStr) return false // Value was not default so changing to default is allowed
      }

      return currentValueStr === defaultValueStr
    }
  }

  updateTabDirection(event) {
    const tabDirection = event.shiftKey ? -1 : 1
    return this.liveInputs.setTabDirection(tabDirection)
  }

  initializeOriginalValue($input) {
    if ($input.data('originalValue') === undefined) {
      return $input.data('originalValue', $input.val())
    }
  }
}
